import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
} from 'recharts';

const formatCurrency = (value) => `$${Math.abs(value).toLocaleString()}`;

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload) return null;
  return (
    <Box sx={{ bgcolor: 'background.paper', p: 1.5, border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
      <Typography variant="body2" fontWeight={600}>{label}</Typography>
      {payload.map((entry) => (
        <Typography key={entry.name} variant="body2" sx={{ color: entry.color }}>
          {entry.name}: {formatCurrency(entry.value)}
        </Typography>
      ))}
    </Box>
  );
};

export default function MonthlyBarChart({ data, title = 'Monthly Income vs Expenses' }) {
  const chartData = (data || []).map((m) => ({
    name: m.month_name?.substring(0, 3) || `M${m.month}`,
    Income: m.income,
    Expenses: m.expenses,
  }));

  return (
    <Card>
      <CardContent sx={{ p: 3 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>{title}</Typography>
        {chartData.length === 0 ? (
          <Typography color="text.secondary" sx={{ py: 4, textAlign: 'center' }}>
            No data available. Upload budget files to see charts.
          </Typography>
        ) : (
          <ResponsiveContainer width="100%" height={420}>
            <BarChart data={chartData} margin={{ top: 5, right: 20, left: 30, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
              <XAxis dataKey="name" />
              <YAxis tickFormatter={formatCurrency} width={80} />
              <Tooltip content={<CustomTooltip />} />
              <Legend />
              <Bar dataKey="Income" fill="#2e7d32" radius={[4, 4, 0, 0]} />
              <Bar dataKey="Expenses" fill="#d32f2f" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  );
}
